import React from "react";
const ReportIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" width="1em" height="1em" style={{ transform: "rotate(360deg)" }} preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
    <path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM19 14.9L14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1v5.8z" fill="#FF0000" />
    <circle cx="12" cy="16" r="1" fill="#FF0000" />
    <path d="M11 7h2v7h-2z" fill="#FF0000" />
    <rect x="0" y="0" width="24" height="24" fill="rgba(0, 0, 0, 0)" />
  </svg>
);
export default ReportIcon;
